/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConversationChannel } from '../models/ConversationChannel';
import type { SenderAvailabilityResponse } from '../models/SenderAvailabilityResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingSendersService {
    /**
     * Returns connection availability without integration-read access.
     * @param channel Canonical channel; only WhatsApp has an evaluator at present.
     * @param senderId Stable channel-provider sender ID. Preferred whenever the caller has one.
     * @param sender Legacy channel address used only when senderId is absent.
     * @returns SenderAvailabilityResponse Connection state, not recipient or message eligibility.
     * @throws ApiError
     */
    public static getSenderAvailability(
        channel: ConversationChannel,
        senderId?: string,
        sender?: string,
    ): CancelablePromise<SenderAvailabilityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messaging/senders/availability',
            query: {
                'channel': channel,
                'senderId': senderId,
                'sender': sender,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
